// Duplicate of apps/app/src/time-sync.ts. Kept in sync by hand until
// the monorepo grows a real shared package.

let offsetMs = 0;
let lastSyncMs = 0;
let lastSyncRttMs = 0;
let hasSyncedOnce = false;
const RESYNC_INTERVAL_MS = 30_000;

export async function syncTime(): Promise<number> {
  const t0 = Date.now();
  try {
    const res = await fetch('/api/time', { credentials: 'omit', cache: 'no-store' });
    if (!res.ok) return offsetMs;
    const body = (await res.json()) as { now: number };
    const t1 = Date.now();
    const serverMid = body.now - (t1 - t0) / 2;
    const clientMid = (t0 + t1) / 2;
    offsetMs = serverMid - clientMid;
    lastSyncMs = t1;
    lastSyncRttMs = t1 - t0;
    hasSyncedOnce = true;
    if (typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.log(
        `[time-sync] offset=${offsetMs.toFixed(0)}ms rtt=${lastSyncRttMs}ms (client ${
          offsetMs > 0 ? 'behind' : 'ahead of'
        } server by ${Math.abs(offsetMs).toFixed(0)}ms)`,
      );
    }
  } catch (e) {
    if (typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('[time-sync] failed:', e);
    }
  }
  return offsetMs;
}

export function serverNow(): number {
  if (Date.now() - lastSyncMs > RESYNC_INTERVAL_MS) {
    void syncTime();
  }
  return Date.now() + offsetMs;
}

export function isSynced(): boolean {
  return hasSyncedOnce;
}

export function getClockOffsetMs(): number {
  return offsetMs;
}

let initialSyncPromise: Promise<void> | null = null;
let resyncInterval: ReturnType<typeof setInterval> | null = null;

export function startTimeSync(): Promise<void> {
  if (initialSyncPromise) return initialSyncPromise;
  initialSyncPromise = syncTime().then(() => {
    if (!resyncInterval) {
      resyncInterval = setInterval(() => {
        void syncTime();
      }, RESYNC_INTERVAL_MS);
    }
  });
  return initialSyncPromise;
}
